import {
  INIT_METADATA,
  INIT_CONFIG,
  SET_LANG,
  SET_ACTIVITY,
  SET_USER_SESSION
} from './actions';

function proceduresArrayFromSession(userSession) {
  const pl = userSession?.procedures_list;
  if (Array.isArray(pl)) return pl;
  if (pl && Array.isArray(pl.procedures)) return pl.procedures;
  if (pl?.procedures_list && Array.isArray(pl.procedures_list.procedures)) {
    return pl.procedures_list.procedures;
  }
  return [];
}

const INITIAL_STATE = {
  metadata: {},
  config: {},
  lang: "es",
  activity: false,
  userSession: null,          // Agregamos el estado para la sesión del usuario
  proceduresList: [] 
};

const app = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INIT_METADATA:
      return {
        ...state,
        metadata: action.metadata
      };
    case INIT_CONFIG:
      return {
        ...state,
        config: action.config
      };
    case SET_LANG:
      return {
        ...state,
        lang: action.lang
      };
    case SET_ACTIVITY:
      return {
        ...state,
        activity: action.activity
      };
    case SET_USER_SESSION:
      return {
        ...state,
        userSession: action.userSession,
        proceduresList: proceduresArrayFromSession(action.userSession)
      };      
    default:
      return state;
  }
};

export default app;
